import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AdditionalRolesFormGroup } from '../create-user-form-groups';
import { DropDownItem } from '../../../../../models/shared/stylesheet/drop-down-item';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';

@Component({
  selector: 'app-create-user-additional-roles-form-grid',
  templateUrl: './create-user-additional-roles-form-grid.component.html',
  styleUrls: ['./create-user-additional-roles-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateUserAdditionalRolesFormGridComponent {
  @Input({ required: true }) form!: AdditionalRolesFormGroup;
  @Input({ required: true }) formSubmitted!: boolean;
  @Input() roleDropdowns: DropDownItem[] = [];
  @Output() addRole = new EventEmitter<void>();
  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
